// src/components/portal/LimitReached.js
import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { C } from '../../styles/theme';

// ─── Brand tokens ─────────────────────────────────────────────────────────────
const FONT = "'Plus Jakarta Sans', sans-serif";

const SparklesIcon = ({ size = 16 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={C.green}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3z" />
        <path d="M5 17l.75 2.25L8 20l-2.25.75L5 23l-.75-2.25L2 20l2.25-.75L5 17z" />
        <path d="M19 3l.5 1.5L21 5l-1.5.5L19 7l-.5-1.5L17 5l1.5-.5L19 3z" />
    </svg>
);

const LimitReached = ({ cap, requiredPlan = 'Pro', onUpgrade }) => {
    const { t } = useLanguage();

    const handleUpgrade = () => {
        if (typeof onUpgrade === 'function') onUpgrade();
    };

    return (
        <div
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                background: C.greenLight,
                border: `1px solid ${C.greenBorder}`,
                borderRadius: 8,
                padding: '8px 12px',
                fontFamily: FONT,
                fontSize: 12.5,
                color: C.greenDark,
            }}
        >
            <SparklesIcon size={16} />

            <span><strong>{t('limit_reached_msg')}</strong> ({cap})</span>

            {/* Thin separator */}
            <span
                style={{
                    width: 1,
                    height: 12,
                    background: C.greenBorder,
                    display: 'inline-block',
                    flexShrink: 0,
                }}
            />

            <button
                onClick={handleUpgrade}
                style={{ border: 'none', background: 'none', padding: 0, font: 'inherit', color: C.green, fontWeight: 700, cursor: 'pointer', textDecoration: 'underline' }}
            >
                {`${t('upgrade_to_plan')} ${requiredPlan}`}
            </button>
        </div>
    );
};

export default LimitReached;
